import React from 'react';
import classNames from 'classnames';
import defaultTheme from '../../themes/default';

const Backdrop = React.forwardRef(({ className, ...otherProps }, ref) => (
  <div
    ref={ref}
    className={classNames(defaultTheme.backdrop.base, className)}
    {...otherProps}
  />
));

export default Backdrop;
